import * as React from 'react'
const Svg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={159} height={152} fill="none">
    <g filter="url(#a)">
      <rect
        width={213.818}
        height={127.299}
        x={1}
        y={42.389}
        fill="url(#b)"
        rx={6.234}
        transform="rotate(-5.472 1 42.39)"
      />
      <g fill="#fff" filter="url(#c)">
        <path d="M14.858 64.187 13.855 53.72l2.306-.22.403 4.201 4.775-.457-.403-4.202 2.321-.223 1.003 10.468-2.32.223-.418-4.35-4.775.457.417 4.35-2.306.221ZM25.861 63.133l-.72-7.528 2.231-.214.722 7.528-2.233.214Zm-.928-8.752-.2-2.094 2.395-.229.2 2.094-2.395.229ZM29.856 65.987l-.84-8.775c-.031-.317-.072-.638-.123-.963a16.337 16.337 0 0 0-.184-.986l2.144-.205.318 1.453-.163.015c.1-.509.374-.93.82-1.262.444-.342.972-.543 1.583-.601.65-.063 1.237.041 1.76.31.522.26.95.669 1.281 1.227.342.556.552 1.24.63 2.052.078.822.003 1.538-.227 2.15-.22.61-.561 1.097-1.024 1.461-.462.364-1.019.577-1.67.64a3.059 3.059 0 0 1-1.652-.276c-.49-.243-.837-.595-1.04-1.055l.177-.017.442 4.618-2.232.214Zm3.464-5.112c.522-.05.923-.273 1.204-.67.28-.396.384-.975.31-1.738-.073-.762-.284-1.306-.633-1.632-.35-.326-.786-.464-1.308-.414-.513.049-.914.267-1.206.655-.28.386-.385.96-.312 1.723.073.762.285 1.311.635 1.647.36.335.797.478 1.31.43ZM38.827 65.128l-.84-8.776c-.031-.316-.072-.637-.123-.962a16.26 16.26 0 0 0-.184-.986l2.144-.206.318 1.453-.162.016c.1-.51.373-.93.819-1.262.444-.343.972-.543 1.583-.602.65-.062 1.237.042 1.76.311.523.26.95.669 1.282 1.226.341.557.551 1.241.629 2.053.079.821.003 1.538-.227 2.15-.22.61-.561 1.097-1.023 1.46-.463.365-1.02.578-1.67.64a3.059 3.059 0 0 1-1.653-.276c-.49-.243-.837-.594-1.04-1.054l.177-.017.442 4.618-2.232.214Zm3.464-5.112c.522-.05.924-.274 1.204-.67.28-.396.384-.976.31-1.738-.072-.762-.283-1.306-.633-1.633-.35-.326-.785-.464-1.308-.414-.512.05-.914.268-1.205.655-.282.387-.386.961-.313 1.723.074.763.285 1.312.636 1.648.36.335.796.478 1.309.429ZM51.055 60.885c-.799.076-1.509-.016-2.13-.276a3.494 3.494 0 0 1-1.491-1.236c-.372-.554-.596-1.236-.674-2.048-.077-.802.015-1.51.274-2.124.27-.615.68-1.11 1.23-1.482.562-.373 1.241-.598 2.04-.675.798-.076 1.508.016 2.13.276.621.26 1.118.667 1.49 1.22.38.554.61 1.231.686 2.033.078.812-.018 1.525-.287 2.14a3.37 3.37 0 0 1-1.23 1.497c-.56.373-1.24.598-2.038.675Zm-.162-1.693c.512-.05.899-.271 1.16-.666.27-.395.368-.974.295-1.736-.073-.763-.279-1.307-.619-1.634-.33-.328-.75-.468-1.263-.419-.513.05-.905.267-1.176.652-.261.385-.356.958-.283 1.72.073.763.275 1.313.606 1.65.34.338.767.482 1.28.433ZM56.191 60.228 55.19 49.76l4.863-.466c1.173-.113 2.088.09 2.744.606.665.506 1.045 1.253 1.14 2.243.094.98-.137 1.791-.692 2.434-.546.632-1.406 1.004-2.578 1.116l-2.558.245.39 4.069-2.307.22Zm1.745-6.087 2.262-.216c.552-.053.949-.216 1.191-.489.252-.274.357-.633.315-1.079-.043-.445-.214-.774-.513-.985-.29-.222-.71-.306-1.262-.254l-2.262.217.269 2.806ZM68.246 59.238c-.65.062-1.237-.042-1.76-.311-.523-.27-.951-.683-1.283-1.241-.332-.558-.537-1.247-.616-2.069-.078-.811-.007-1.523.213-2.133.22-.61.562-1.093 1.026-1.447.462-.364 1.019-.577 1.669-.64a2.98 2.98 0 0 1 1.654.292c.51.24.863.601 1.059 1.082l-.163.016.037-1.487 2.143-.206.007 1.004c.011.328.032.651.063.968l.533 5.568-2.218.212-.15-1.409.178-.017c-.112.49-.391.902-.837 1.234a3.03 3.03 0 0 1-1.555.584Zm.518-1.758c.512-.05.909-.272 1.19-.669.28-.396.383-.975.31-1.738-.073-.762-.284-1.306-.634-1.632-.35-.326-.78-.465-1.293-.416-.512.05-.91.267-1.19.654-.282.386-.386.96-.313 1.723.073.762.28 1.312.62 1.649.351.336.788.479 1.31.429ZM74.275 58.495l-.531-5.538a17.046 17.046 0 0 0-.125-.992 11.036 11.036 0 0 0-.17-.988l2.145-.205.461 2.173-.34.033c.048-.544.163-1 .347-1.367.193-.368.445-.652.754-.851.319-.2.69-.321 1.114-.362a2.61 2.61 0 0 1 .446-.013c.11 0 .22.014.332.043l.175 1.977a2.11 2.11 0 0 0-.548-.113 2.62 2.62 0 0 0-.536.007c-.414.04-.752.152-1.013.336a1.51 1.51 0 0 0-.539.756c-.099.32-.127.697-.085 1.132l.36 3.757-2.248.215ZM79.998 57.947 78.95 47.019l2.232-.214.626 6.533.03-.003 2.479-3.399 2.66-.255-3.208 4.353-.078-.816 4.2 3.973-2.735.262-3.21-2.99-.03.004.313 3.266-2.232.214ZM88.117 57.17l-.721-7.529 2.232-.214.722 7.528-2.233.214Zm-.928-8.753-.2-2.093 2.395-.23.2 2.094-2.395.23ZM91.804 56.816l-.533-5.568a16.337 16.337 0 0 0-.306-1.949l2.144-.205.296 1.38-.177.017a2.69 2.69 0 0 1 .94-1.244c.427-.31.942-.495 1.543-.552.877-.084 1.557.11 2.04.584.492.462.79 1.228.892 2.297l.435 4.543-2.232.214-.426-4.44c-.052-.544-.187-.92-.406-1.13-.22-.208-.526-.294-.92-.256-.493.047-.872.243-1.137.589-.266.335-.374.765-.324 1.29l.404 4.216-2.233.214ZM104.383 58.968c-.72.068-1.367.056-1.943-.039a4.943 4.943 0 0 1-1.569-.494l.275-1.645c.293.152.597.268.913.347.327.089.655.142.985.16.341.028.674.026.999-.005.661-.063 1.138-.269 1.433-.617.295-.348.414-.814.359-1.398l-.15-1.559.148-.014c-.112.49-.391.901-.837 1.234a3.029 3.029 0 0 1-1.555.584c-.67.064-1.271-.034-1.803-.292a3.114 3.114 0 0 1-1.279-1.197c-.33-.537-.531-1.187-.604-1.95-.073-.762.001-1.438.223-2.029.222-.59.565-1.058 1.03-1.402.473-.355 1.045-.565 1.715-.629.601-.058 1.142.035 1.623.28.49.232.836.573 1.038 1.024l-.124-.048.02-1.351 2.158-.207c-.008.33-.006.665.007 1.004.011.328.032.65.063.968l.49 5.122c.117 1.218-.134 2.18-.752 2.89-.618.718-1.572 1.139-2.863 1.263Zm-.439-5.203c.522-.05.919-.268 1.191-.654.271-.385.375-.91.312-1.573-.064-.663-.265-1.153-.604-1.47-.34-.328-.771-.466-1.293-.416-.542.052-.954.271-1.235.658-.272.375-.377.895-.313 1.558.063.663.265 1.159.605 1.486.349.326.795.463 1.337.411Z" />
      </g>
      <rect
        width={213.507}
        height={126.987}
        x={1.17}
        y={42.53}
        stroke="url(#d)"
        strokeWidth={0.312}
        rx={6.078}
        transform="rotate(-5.472 1.17 42.53)"
      />
    </g>
    <g filter="url(#e)">
      <rect
        width={213.818}
        height={127.299}
        x={40.84}
        y={1}
        fill="url(#f)"
        rx={6.234}
        transform="rotate(4.884 40.84 1)"
      />
      <g fill="#fff" filter="url(#g)">
        <path d="m50.553 24.934.896-10.478 2.308.197-.36 4.206 4.78.409.36-4.206 2.323.198-.896 10.478-2.323-.198.372-4.355-4.78-.408-.371 4.354-2.309-.197ZM61.567 25.875l.644-7.535 2.234.19-.644 7.536-2.234-.19Zm.66-8.776.18-2.096 2.397.205-.18 2.096-2.396-.205ZM64.983 29.4l.75-8.783a16.347 16.347 0 0 0 .05-1.972l2.146.184.052 1.486-.163-.014c.19-.482.534-.847 1.032-1.094.5-.257 1.055-.36 1.666-.307.651.056 1.21.263 1.676.622.467.35.814.828 1.04 1.437.236.609.32 1.32.25 2.132-.07.822-.273 1.513-.61 2.073-.326.561-.749.98-1.27 1.254-.52.275-1.105.385-1.756.33a3.058 3.058 0 0 1-1.576-.57c-.44-.327-.718-.735-.835-1.224l.178.015-.395 4.623-2.235-.191Zm4.327-4.405c.523.044.957-.103 1.305-.443.347-.34.553-.89.618-1.653.065-.763-.045-1.337-.33-1.72-.285-.384-.69-.598-1.212-.643-.513-.044-.948.099-1.304.428-.346.33-.552.876-.617 1.639-.065.763.045 1.34.329 1.734.294.395.698.614 1.21.658ZM73.963 30.168l.75-8.784a16.272 16.272 0 0 0 .05-1.972l2.145.184.052 1.486-.163-.013c.19-.483.535-.848 1.033-1.095.499-.257 1.054-.359 1.666-.307.65.056 1.21.263 1.676.623.467.349.813.828 1.04 1.436.236.609.319 1.32.25 2.132-.07.822-.274 1.514-.61 2.074-.326.56-.75.979-1.27 1.254s-1.106.384-1.757.329a3.058 3.058 0 0 1-1.576-.57c-.439-.326-.717-.734-.834-1.223l.177.015-.395 4.622-2.234-.19Zm4.326-4.406c.523.045.958-.103 1.305-.442.347-.34.553-.891.618-1.654.066-.763-.044-1.336-.33-1.72-.285-.384-.689-.598-1.212-.643-.513-.043-.947.1-1.303.428-.346.33-.552.876-.617 1.639-.065.763.044 1.341.329 1.735.294.394.697.613 1.21.657ZM86.754 28.192c-.799-.068-1.48-.286-2.046-.654a3.495 3.495 0 0 1-1.244-1.483c-.266-.612-.364-1.324-.294-2.136.068-.803.285-1.483.65-2.04a3.394 3.394 0 0 1 1.478-1.237c.619-.266 1.328-.365 2.127-.297.799.068 1.48.286 2.046.654.564.367.98.857 1.245 1.469.276.612.38 1.32.31 2.122-.069.813-.291 1.497-.666 2.054a3.37 3.37 0 0 1-1.479 1.25c-.619.267-1.328.367-2.127.298Zm.145-1.694c.513.044.933-.105 1.26-.446.337-.34.539-.892.604-1.655.065-.763-.04-1.336-.315-1.719-.266-.382-.655-.595-1.168-.639-.513-.044-.938.1-1.274.43-.326.332-.522.879-.587 1.642-.066.763.034 1.34.299 1.732.274.393.668.611 1.181.655ZM91.925 28.47l.896-10.478 4.868.416c1.174.1 2.037.463 2.59 1.09.563.616.803 1.42.718 2.411-.084.98-.457 1.738-1.118 2.27-.651.523-1.563.735-2.737.634l-2.56-.218-.348 4.072-2.309-.198Zm2.81-5.674L97 22.99c.553.047.973-.042 1.26-.267.298-.224.465-.559.504-1.005.038-.446-.071-.8-.327-1.06-.245-.271-.644-.43-1.197-.477l-2.264-.194-.24 2.81ZM103.961 29.663c-.651-.056-1.209-.263-1.675-.623-.467-.359-.813-.842-1.039-1.45-.226-.609-.304-1.324-.234-2.146.069-.813.267-1.5.593-2.06.327-.562.749-.975 1.269-1.24.52-.274 1.106-.384 1.757-.328a2.98 2.98 0 0 1 1.575.583c.459.329.741.747.847 1.255l-.163-.014.303-1.456 2.146.183-.174.989c-.048.325-.085.646-.112.963l-.477 5.573-2.219-.19.106-1.412.177.015c-.198.462-.546.816-1.045 1.063a3.03 3.03 0 0 1-1.635.295Zm.826-1.636c.513.043.943-.105 1.29-.444.347-.34.553-.891.618-1.654.065-.763-.045-1.336-.33-1.72-.285-.383-.684-.597-1.197-.641-.513-.044-.943.099-1.289.429-.346.33-.552.876-.617 1.639-.065.763.04 1.34.314 1.733.285.394.688.613 1.211.658ZM110.025 30.016l.474-5.543c.028-.327.046-.66.055-.999.019-.337.023-.671.012-1.002l2.145.184.064 2.22-.341-.028c.145-.527.34-.954.587-1.283.256-.327.555-.561.895-.702a2.51 2.51 0 0 1 1.161-.155c.187.016.334.039.441.068.108.019.214.053.319.102l-.184 1.975a2.102 2.102 0 0 0-.518-.209 2.63 2.63 0 0 0-.529-.09c-.414-.035-.767.015-1.056.15-.28.135-.502.35-.667.646-.154.296-.25.662-.287 1.098l-.322 3.76-2.249-.192ZM115.754 30.506l.934-10.939 2.235.191-.559 6.54.03.002 3.05-2.898 2.663.227-3.939 3.706.07-.818 3.418 4.664-2.738-.234-2.621-3.517-.029-.003-.28 3.27-2.234-.191ZM123.881 31.2l.644-7.535 2.234.191-.644 7.535-2.234-.19Zm.66-8.776.179-2.096 2.398.205-.18 2.096-2.397-.205ZM127.571 31.516l.477-5.574a16.856 16.856 0 0 0 .049-1.972l2.146.184.043 1.41-.178-.014a2.689 2.689 0 0 1 1.149-1.055c.476-.229 1.016-.317 1.617-.266.878.075 1.512.389 1.902.941.401.543.556 1.35.464 2.42l-.388 4.548-2.235-.191.38-4.444c.047-.545-.019-.94-.197-1.184-.178-.245-.464-.384-.858-.418-.494-.042-.902.082-1.225.374-.322.282-.506.686-.55 1.21l-.361 4.222-2.235-.191ZM139.558 35.893c-.72-.061-1.355-.19-1.905-.387a4.94 4.94 0 0 1-1.454-.768l.566-1.568c.261.202.54.37.836.505.306.146.619.258.941.335.33.088.658.146.983.174.661.056 1.168-.06 1.521-.35.352-.288.554-.725.604-1.31l.133-1.56.148.012c-.199.462-.547.817-1.045 1.064a3.03 3.03 0 0 1-1.635.294c-.671-.057-1.245-.261-1.721-.611a3.118 3.118 0 0 1-1.043-1.407c-.228-.588-.309-1.264-.244-2.026.065-.764.26-1.415.585-1.957.324-.54.746-.939 1.264-1.194.53-.264 1.13-.368 1.801-.31.601.051 1.117.24 1.546.566.44.317.719.715.837 1.194l-.113-.07.262-1.324 2.16.184c-.067.324-.125.653-.173.989-.048.325-.086.646-.113.963l-.438 5.128c-.104 1.218-.524 2.12-1.26 2.706-.736.596-1.751.839-3.043.728Zm.504-5.196c.523.044.952-.098 1.289-.43.336-.33.532-.827.589-1.49.057-.665-.053-1.183-.329-1.556-.275-.383-.675-.596-1.197-.641-.543-.046-.987.095-1.333.425-.336.32-.532.813-.589 1.477-.056.663.053 1.187.328 1.57.285.383.699.598 1.242.645Z" />
      </g>
      <rect
        width={213.507}
        height={126.987}
        x={40.982}
        y={1.169}
        stroke="url(#h)"
        strokeWidth={0.312}
        rx={6.078}
        transform="rotate(4.884 40.982 1.169)"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={3.771}
        x2={221.697}
        y1={42.389}
        y2={161.491}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#222B45" />
        <stop offset={0.567} stopColor="#2F3B60" />
        <stop offset={1} stopColor="#222B45" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={192.533}
        x2={8.948}
        y1={161.922}
        y2={44.571}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.766} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={43.611}
        x2={261.537}
        y1={1}
        y2={120.102}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2697FF" />
        <stop offset={0.608} stopColor="#6CC1FF" />
        <stop offset={1} stopColor="#2697FF" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={232.372}
        x2={48.788}
        y1={120.533}
        y2={3.182}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.766} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <filter
        id="a"
        width={228.1}
        height={150.225}
        x={0.065}
        y={21.065}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.623} dy={0.623} />
        <feGaussianBlur stdDeviation={0.779} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0778472 0 0 0 0 0.090725 0 0 0 0 0.158333 0 0 0 0.39 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2701_11851" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_2701_11851" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.67} dy={0.67} />
        <feGaussianBlur stdDeviation={0.67} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.48 0" />
        <feBlend in2="shape" result="effect2_innerShadow_2701_11851" />
      </filter>
      <filter
        id="c"
        width={95.418}
        height={21.14}
        x={13.543}
        y={45.782}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.312} dy={0.312} />
        <feGaussianBlur stdDeviation={0.312} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2701_11851" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_2701_11851" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.623} dy={0.312} />
        <feGaussianBlur stdDeviation={0.312} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.0862847 0 0 0 0 0.120823 0 0 0 0 0.145833 0 0 0 0.15 0" />
        <feBlend in2="shape" result="effect2_innerShadow_2701_11851" />
      </filter>
      <filter
        id="e"
        width={226.998}
        height={148.159}
        x={29.066}
        y={0.065}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.623} dy={0.623} />
        <feGaussianBlur stdDeviation={0.779} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0778472 0 0 0 0 0.090725 0 0 0 0 0.158333 0 0 0 0.39 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2701_11851" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_2701_11851" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.67} dy={0.67} />
        <feGaussianBlur stdDeviation={0.67} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.48 0" />
        <feBlend in2="shape" result="effect2_innerShadow_2701_11851" />
      </filter>
      <filter
        id="g"
        width={95.279}
        height={22.71}
        x={50.242}
        y={14.144}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.312} dy={0.312} />
        <feGaussianBlur stdDeviation={0.312} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2701_11851" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_2701_11851" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={0.623} dy={0.312} />
        <feGaussianBlur stdDeviation={0.312} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.0862847 0 0 0 0 0.120823 0 0 0 0 0.145833 0 0 0 0.15 0" />
        <feBlend in2="shape" result="effect2_innerShadow_2701_11851" />
      </filter>
    </defs>
  </svg>
)
export default Svg
